<template>
  <div>
    <template v-if="thumbnail_mode">
      <img class="img-fluid" :src="getThumbnailSrc" />
    </template>
    <template v-else>
      <div class="embed-responsive" :class="getTransformedRatio">
        <iframe
          class="embed-responsive-item"
          :width="width"
          :height="height"
          :src="getVideoSrc"
          :allow="allow"
          :allowfullscreen="allow_fullscreen"
          :frameborder="frameborder"
        ></iframe>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "iframe-video",

  props: {
    width: {
      type: Number,
      description: "Width",
      default: null,
    },
    height: {
      type: Number,
      description: "Height",
      default: null,
    },
    src: {
      type: String,
      description: "Source",
    },
    thumbnail_mode: {
      type: Boolean,
      description: "Thumbnail Mode",
      default: false,
    },
    allow: {
      type: String,
      description: "Allow",
      default: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    },
    allow_fullscreen: {
      type: Boolean,
      description: "Fullscreen",
      default: true,
    },
    frameborder: {
      type: Number,
      description: "Frameborder",
      default: 0,
    },
    ratio: {
      type: String,
      description: "Ratio",
      default: "16:9",
    }
  },

  computed: {
    getTransformedRatio() {
      const _class = 'embed-responsive-'
      if (this.ratio.includes(":")) {
        return _class + this.ratio.replace(":", "by")
      } else {
        if (this.ratio.includes('by')) {
          return _class + this.ratio
        } else {
          return _class + '16by9'
        }
      }
    },

    getVideoSrc() {
      if (this.src.includes('youtube.com')) {
        return this.getYoutubeEmbedUrl(this.src)
      }

      return this.src
    },

    getThumbnailSrc() {
      if (this.src.includes('youtube.com')) {
        return this.getYoutubeThumbnail(this.src)
      }

      return ''
    }
  },

  methods: {
    getYoutubeEmbedUrl(url) {
      const id = this.getYoutubeId(url)
      return `https://www.youtube.com/embed/${id}`
    },

    getYoutubeThumbnail(url) {
      const id = this.getYoutubeId(url)
      const thumbnail_no = 0
      return `http://img.youtube.com/vi/${id}/${thumbnail_no}.jpg`
    },

    getYoutubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regExp)

      return (match && match[2].length === 11)
        ? match[2]
        : null
    }
  },
}
</script>